import PointCloudViewerContent from "./PointCloudViewerContent";

export default PointCloudViewerContent;

